import React from 'react'

import { Modal, Alert, Typography, Spin } from 'antd'
import { Button } from 'primereact/button'

import CardDownload from '../CardDownload/cardDownload'

export default function ConfirmImportModal({
  visible,
  onCancel,
  onConfirm,
  onDownloadTemplate,
  templateMode,
  dataLoadId,
  onDownloadErrors,
  tipoLabel = 'Importação',
  precheckLoading,
  existingImport,
  isSubmitting,
  jobError,
  success,
  resultStats
}) {
  const showActions = visible && !isSubmitting && !success && !jobError

  const showTemplateCard = !!templateMode && !isSubmitting && !success

  const OBSOLETE_TEMPLATE_MSG =
    'Esse modelo de importação está obsoleto. Atualize a página e baixe um novo modelo para a inserção'

  const isObsoleteTemplateError =
    typeof jobError === 'string' && jobError.trim().toLowerCase() === OBSOLETE_TEMPLATE_MSG.toLowerCase()

  const showResultCard = (success || jobError) && !isSubmitting && !isObsoleteTemplateError

  const resultSubtitle = success
    ? 'Baixe o arquivo importado com sucesso de resultados desta importação'
    : 'Baixe o arquivo de erros desta importação'

  return (
    <Modal
      footer={null}
      onCancel={onCancel}
      width="44%"
      visible={visible}
      maskClosable={false}
      destroyOnClose
      title={existingImport ? tipoLabel : 'Carga de Dados'}
    >
      {resultStats && (
        <div style={{ display: 'flex', gap: 18, alignItems: 'center', marginTop: 6 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="pi pi-chevron-circle-down" style={{ color: '#22c55e', fontSize: 18 }} />
            <span style={{ fontWeight: 700 }}>{resultStats.created}</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="pi pi-exclamation-triangle" style={{ color: '#f59e0b', fontSize: 18 }} />
            <span style={{ fontWeight: 700 }}>{resultStats.ignored}</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="pi pi-times-circle" style={{ color: '#ef4444', fontSize: 18 }} />
            <span style={{ fontWeight: 700 }}>{resultStats.rejected}</span>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {precheckLoading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Spin />
            <Typography.Text>Verificando importações anteriores...</Typography.Text>
          </div>
        )}

        <CardDownload
          show={showTemplateCard}
          title={
            templateMode === 'update'
              ? 'Template para Atualização de Visitas GD Externa'
              : 'Template para Criação de Visitas GD Externa'
          }
          subtitle="Baixe o modelo para preencher e importar."
          onClick={() => onDownloadTemplate?.()}
          disabled={!templateMode}
        />

        {isSubmitting && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Spin />
            <Typography.Text>Enviando arquivo e iniciando importação de Dados...</Typography.Text>
          </div>
        )}

        {success && !jobError && (
          <div style={{ marginTop: '5px' }}>
            <Alert type="success" showIcon message="Sucesso!" description="A importação foi processada com sucesso." />
          </div>
        )}

        {jobError && <Alert type="error" showIcon message="Erro" description={jobError} />}

        <CardDownload
          show={showResultCard}
          title="Resultado da Importação"
          subtitle={resultSubtitle}
          onClick={() => onDownloadErrors?.()}
          disabled={!dataLoadId}
        />

        {showActions && (
          <>
            <Alert
              type="info"
              showIcon
              message="Confirmação de Importação"
              description="Se deseja confirmar a importação, clique em Confirmar. Após iniciar, o processo não poderá ser desfeito."
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 }}>
              <Button className="p-button-text" label="Cancelar" onClick={onCancel} />
              <Button className="btnNewImport" label="Confirmar" onClick={onConfirm} />
            </div>
          </>
        )}
      </div>
    </Modal>
  )
}
